<template>
    <div class="container-fluid">
        <!-- breadbrumb -->
        <app-breadcrumb pageTitle="Dashboard"></app-breadcrumb>
        
        <!-- display -->
        <div v-if="myDashboard" class="row my-dashboard">
            <div class="col-12">
                <div class="jumbotron text-center">
                    <div class="row">
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6 mb-5">
                            <router-link :to="{ name: 'items' }">
                                <i class="fas fa-camera fa-4x"></i>
                                <p class="small">Items ({{myDashboard.items}})</p>
                            </router-link>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6 mb-5">
                            <router-link :to=" { name: 'wallet' }">
                                <i class="fas fa-wallet fa-4x"></i>
                                <p class="small">
                                    Money 
                                    <span v-if="myDashboard.revenue" class="text-uppercase">
                                        ({{user.currency}} {{myDashboard.revenue | money}})
                                    </span>
                                </p>
                            </router-link>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6 mb-5">
                            <router-link :to="{ name: 'on-sale' }">
                                <i class="fas fa-tags fa-4x"></i>
                                <p class="small">On-Sale ({{myDashboard.onSale}})</p>
                            </router-link>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6 mb-5">
                            <router-link :to="{ name: 'activities' }">
                                <i class="fas fa-history fa-4x"></i>
                                <p class="small">Activities ({{myDashboard.activities}})</p>
                            </router-link>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6 mb-5">
                            <router-link :to="{ name: 'shoppers' }">
                                <i class="fas fa-users fa-4x"></i>
                                <p class="small">Shoppers ({{myDashboard.shoppers}})</p>
                            </router-link>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6 mb-5">
                            <router-link :to=" { name: 'donations' }">
                                <i class="fas fa-gifts fa-4x"></i>
                                <p class="small">Donations ({{myDashboard.donations}})</p>
                            </router-link>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6 mb-5">
                            <router-link :to="{ name: 'promotions' }">
                                <i class="fas fa-fire fa-4x"></i>
                                <p class="small">Promotions ({{myDashboard.promotions}})</p>
                            </router-link>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6 mb-5">
                            <router-link :to="{ name: 'performance' }">
                                <i class="fas fa-chart-line fa-4x"></i>
                                <p class="small">Performance</p>
                            </router-link>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6 mb-5">
                            <router-link :to="{ name: 'shop-settings' }">
                                <i class="fas fa-tools fa-4x"></i>
                                <p class="small">Settings</p>
                            </router-link>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6 mb-5">
                            <router-link :to="{ name: 'main-categories' }">
                                <i class="fas fa-layer-group fa-4x"></i>
                                <p class="small">Categories</p>
                            </router-link>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6 mb-5">
                            <router-link :to="{ name: 'shipping-fees' }">
                                <i class="fas fa-shipping-fast fa-4x"></i>
                                <p class="small">Shipping</p>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { webpageTitle } from '@/store/dry'

import LayoutShop from '@/layouts/Shop.vue'
import Breadcrumb from '../shared/Breadcrumb.vue'

export default {
    name: "Dashboard",
    methods: {
        ...mapActions(['fetchDashboard']),
    },
    computed: {
        ...mapGetters(['user', 'dashboard']),
        myDashboard() {
            if(this.dashboard && this.dashboard !== null){
                return this.dashboard
            }
            return false
        },
    },
    components: {
        appBreadcrumb: Breadcrumb
    },
    created() {
        webpageTitle(`Happy zone`)
        this.fetchDashboard().then(() => {}).catch((e) => {})
        this.$emit('update:layout', LayoutShop)
    }
}
</script>